import React from "react";
import "./terms-conditions.css";

const PrivacyPolicy = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Privacy Policy</h1>
      </header>

      <section className="tc-content mb-3">
        <p>At Fundswalle, a lending platform operated under Marathon Finlease Private Limited, we are committed to safeguarding your privacy and ensuring the highest standards of data protection.</p>

        <p>This Privacy Policy outlines how we collect, use, store, and protect your personal and financial information. By accessing or using Fundswalle’s website and services, you consent to the collection and processing of your information in accordance with this Privacy Policy.
We encourage you to read this policy carefully to understand how your data is handled and the choices available to you regarding its use.
</p>

        <h2>Information We Collect</h2>
        <p>To provide our lending services effectively and securely, Fundswalle collects the following categories of information from applicants and users:</p>

        <ol>

        <li> <b>Personal Identification: </b> Includes your full name, email address, phone number, date of birth, residential address, PAN, Aadhaar number, employment details, bank account information, and other relevant financial data.</li>

        <li> <b> Financial Information:</b> Covers documents such as bank statements, salary slips, income proofs, and your consent for credit bureau checks, which are essential for assessing eligibility and processing loan applications.</li>

        <li> <b> Transactional Information: </b> Comprises details related to your approved loans, repayment schedules, payment history, and other related financial transactions carried out through Fundswalle’s platform.</li>
       </ol>

        <h2>How We Use Your Information</h2>
        <p>Fundswalle uses the information you provide to ensure a smooth, secure, and compliant lending experience. Your data is utilized for the following purposes:</p>

        <ol>

        <li> <b>Loan Processing: </b> To evaluate loan eligibility, process applications, verify documents, and manage loan disbursement and repayments.</li>

        <li> <b> Service Improvement:</b> To enhance the functionality, user experience, and performance of our platform based on user interactions and feedback.</li>

        <li> <b> Communication: </b> To send important notifications, loan updates, and responses to inquiries related to your application or ongoing services.</li>

        <li><b>Regulatory Compliance:</b> To fulfil statutory and regulatory obligations, including Know Your Customer (KYC), Anti-Money Laundering (AML), and other legal requirements.</li>
       </ol>

        <h2>Sharing Your Information</h2>
        <p>Your information may be shared with the following entities in a secure and responsible manner: </p>

<li> <b>Authorized Third Parties: </b> Credit bureaus, payment gateways, and verification agencies for processing, authentication, and credit assessment.</li>

<li> <b> Legal Authorities: </b> Government or regulatory bodies as required by law for compliance, audits, or fraud prevention.</li>

<li> <b> Parent Company:</b> Marathon Finlease Private Limited for loan evaluation, processing, and related operational purposes.</li>

        <h2>Data Security</h2>
        <p>We use advanced encryption, secure servers, and multi-factor authentication to protect your personal and financial information. While we maintain strict security measures, no system is entirely immune to risks, and users are advised to exercise caution when sharing sensitive data online.</p>

        <h2>Cookies and Tracking</h2>
        <p>We use cookies and similar tracking technologies to improve your browsing experience and personalize content. You can manage or disable cookies anytime through your browser settings, though some features of the website may be affected.</p>

        <h2>Your Rights</h2>

        <p>You have the right to access, update, correct, delete, or request the transfer of your personal data. You may also choose to opt out of receiving marketing or promotional communications from Fundswalle at any time.</p>
     
         <h2>Retention of Information</h2>
        <p>We retain your information only for as long as it is required to fulfill business, regulatory, or legal obligations. Once the data is no longer needed, it is securely deleted or anonymized in accordance with applicable data protection standards.</p>


        <h2>Third-Party Links</h2>
       <p>Our website may contain links to third-party platforms for your convenience. Fundswalle is not responsible for the content, security, or privacy practices of these external websites, and we encourage users to review their respective privacy policies before sharing any information.</p>

         <h2>Children’s Privacy</h2>

      <p>Fundswalle does not knowingly collect or store personal information from individuals under the age of 18. If any such data is identified, it will be promptly deleted from our records in compliance with applicable laws.</p>  

       <h2>Policy Updates</h2>

      <p>This Privacy Policy may be updated periodically to reflect changes in our practices or regulatory requirements. Users are encouraged to review this page from time to time to stay informed about any modifications.</p>  

       <h2>Grievance Redressal Officer</h2>
        <p>Borrowers are requested to address all grievances at the first instance to the Grievance Redressal Officer (GRO).</p>

        <p><b>Name: Shivani Chaudhary<br />
        Designation: Sanction Head<br />
        Company: Marathon Finlease Private Limited (Fundswalle) <br />
        Address: Office no. 304, Laxman Palace, Delhi<br />
        Contact Number: 8800750038 <br />
        Email: shivani@fundswalle.com <br />
          </b></p>

           <h2> Nodal Officer</h2>

        <p><b>Name: Mr. Puneet Dixit <br />
        Designation: Chief Operating Officer <br />
        Company: Marathon Finlease Private Limited (Fundswalle) <br />
        Address: Office no. 304, Laxman Palace, Delhi<br />
        Contact Number: 9599894600<br />
        Email: puneet.dixit@fundswalle.com <br />
          </b></p>

      </section>
    </div>
  );
};

export default PrivacyPolicy;
